import { RowInfo } from 'src/WebApiController';

type GetRowIdsFromRowRangeResult = {
  matched: boolean;
  rowIds: number[];
  upperRowId?: number;
};

export const getRowIdsFromRowRange = (
  rows: RowInfo[],
  rowRange: [string, string]
): GetRowIdsFromRowRangeResult => {
  const [lowerRowName, upperRowName] = rowRange;

  const nameToOrdinal = rows.reduce(
    (res, row) => {
      if (!row.isSpeculative && row.ordinal != null && row.name) {
        res[row.name] = row.ordinal;
      }
      return res;
    },
    {} as Record<string, number>
  );

  const lowerRowOrdinal = nameToOrdinal[lowerRowName];
  const upperRowOrdinal = nameToOrdinal[upperRowName];

  if (lowerRowOrdinal != null && upperRowOrdinal != null) {
    const rowIds = rows
      .filter(
        (row) =>
          row.ordinal != null &&
          row.ordinal >= lowerRowOrdinal &&
          row.ordinal <= upperRowOrdinal
      )
      .map((row) => row.id);

    const upperRowId = rows.find(
      (row) => row.name && row.name === upperRowName
    )?.id;
    return {
      matched: true,
      rowIds: rowIds,
      upperRowId,
    };
  }

  return {
    matched: false,
    rowIds: [],
  };
};

export const getRowRangeFromRowIds = (rows: RowInfo[], rowIds: number[]) => {
  const validRows = rows
    .filter((row) => row.ordinal != null)
    .toSorted((a, b) => a.ordinal! - b.ordinal!);
  const rowIdToRelativeIndex = {} as Record<number, number>;
  for (let index = 0; index < validRows.length; index++) {
    rowIdToRelativeIndex[validRows[index].id] = index;
  }
  const filteredRows = rows
    .filter((row) => rowIds.includes(row.id))
    .toSorted((a, b) => a.ordinal! - b.ordinal!);

  let lowerRowId = null;
  let upperRowId = null;

  for (let index = 0; index + 1 < filteredRows.length; index++) {
    const current = filteredRows[index];
    const next = filteredRows[index + 1];

    if (index === 0) {
      lowerRowId = current.id;
    }
    if (
      rowIdToRelativeIndex[next.id] &&
      rowIdToRelativeIndex[current.id] &&
      rowIdToRelativeIndex[next.id] === rowIdToRelativeIndex[current.id] + 1
    ) {
      upperRowId = next.id;
    } else {
      break;
    }
  }

  if (lowerRowId != null && upperRowId != null) {
    return {
      isRange: lowerRowId !== validRows[0]?.id, // row range start with at least second ordinal
      lowerRowId: lowerRowId,
      upperRowId: upperRowId,
    };
  }

  return undefined;
};
